import { render, staticRenderFns } from "./AuthSSO.vue?vue&type=template&id=501489bc&scoped=true"
import script from "./AuthSSO.vue?vue&type=script&lang=js"
export * from "./AuthSSO.vue?vue&type=script&lang=js"
import style0 from "./AuthSSO.vue?vue&type=style&index=0&id=501489bc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501489bc",
  null
  
)

export default component.exports